export default function Gallery() {
  const photos = [
    {
      src: 'https://storage.helloreaddy.io/project_files/30c86f7f-bbcb-4a08-b3cc-3e2631afcba6/4f3a507b-7a3f-4f1b-8c8b-6bfb14a9f3e6_compressed_ChatGPTReady_Gruppe.webp',
      alt: 'Jugendliche bei einer Teamübung im Kurs „Ready for Work" – gemeinsam eine Holzkonstruktion balancieren',
      title: 'Teamübung Ready for Work – Gruppenarbeit Persönlichkeitsentwicklung',
      caption: 'Ready for Work',
    },
    {
      src: 'https://storage.helloreaddy.io/project_files/30c86f7f-bbcb-4a08-b3cc-3e2631afcba6/bab0ddf5-0f4d-4640-a61f-2ddc327ddb99_compressed_ChatGPT-Image_GG_Gruppe.webp',
      alt: 'Stephanie Wolf moderiert einen Kurs „Stark für die Zukunft" – Teilnehmende heben die Hand',
      title: 'Stephanie Wolf – Ganzheitliche Persönlichkeitsentwicklung im Kurs',
      caption: 'Stark für die Zukunft',
    },
    {
      src: 'https://storage.helloreaddy.io/project_files/30c86f7f-bbcb-4a08-b3cc-3e2631afcba6/c7ef092f-ed55-4b7a-9cb0-f16e49b31da0_compressed_ChatGPTPsyh_Gruppe.webp',
      alt: 'Gruppe im Sitzkreis beim Kurs „Perspektiven entwickeln" – Resilienz und Mindset stärken',
      title: 'Perspektiven entwickeln – Gruppenarbeit Resilienz Mindset',
      caption: 'Perspektiven entwickeln',
    },
  ];

  return (
    <section id="galerie" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
          {photos.map((photo) => (
            <div
              key={photo.caption}
              className="group relative rounded-lg overflow-hidden w-full h-64 md:h-80"
            >
              <img
                src={photo.src}
                alt={photo.alt}
                title={photo.title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-black/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
              <div className="absolute bottom-0 left-0 right-0 p-4 translate-y-2 opacity-0 group-hover:translate-y-0 group-hover:opacity-100 transition-all duration-300">
                <span className="inline-block rounded-full bg-primary-500 text-background-50 px-3 py-1 text-xs font-semibold whitespace-nowrap">
                  {photo.caption}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}